import { Pipe, PipeTransform } from '@angular/core';
import { NamedEntity } from '../models';

@Pipe({
  name: 'listToString',
  pure: false,
})
export class ListToStringPipe<R> implements PipeTransform {
  transform<T extends NamedEntity>(items: T[]): string {
    return items.map((item) => item.name).join(', ');
  }
}
